import { router } from 'next/router'
import { useMemo } from 'react'
import { QUERY_PARAM_CATEGORY_BREADCRUMBS } from '../../constants'

/**
 * @description Transform breadcrumbs to the format used by the `Breadcrumbs` component.
 * @param {array} breadcrumbs
 * @returns {array} transformed breadcrumbs
 */
const sanitizedBreadcrumbs = (breadcrumbs) => {
	// breadcrumbs are in the correct format if they have the `title` and `url` properties.
	// sanitize breadcrumbs if they are in the old format
	return breadcrumbs.map((breadcrumb) => {
		if (breadcrumb.title && breadcrumb.url) {
			return breadcrumb
		}

		return {
			title: breadcrumb.label,
			url: breadcrumb.path,
		}
	})
}

/**
 * @description Get product breadcrumbs.
 *
 * @returns {productBreadcrumbs} The product breadcrumbs array.
 */
export const useProductBreadcrumbs = () => {
	/**
	 * @description Get the product breadcrumbs.
	 * @returns {Array} The product breadcrumbs.
	 */
	const productBreadcrumbs = useMemo(() => {
		const paramBreadcrumbs = router?.query?.[QUERY_PARAM_CATEGORY_BREADCRUMBS] || null

		if (!paramBreadcrumbs) {
			return []
		}

		try {
			const breadcrumbs = JSON.parse(paramBreadcrumbs)
			return sanitizedBreadcrumbs(breadcrumbs)
		} catch (err) {
			return []
		}
	}, [])

	return { productBreadcrumbs }
}
